import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';

@Component({
    selector: 'app-common-library-grid-component',
    templateUrl: './common-library-grid-component.component.html',
    styleUrls: ['./common-library-grid-component.component.scss'],
    standalone: false
})
export class CommonLibraryGridComponentComponent implements OnInit {

  gridAPI: any;
  gridColumnAPI: any;

  rowData: any[] = [];
  columnDefs: any[] = [];

  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };

  paginationPageSize = 10;
  pageSize = 10;

  currentPage = 1;
  totalPages = 0;

  title = '';

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    private jsignalsService: JsignalService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    const type = this.route.snapshot.data['type'];

    if (type === 'IME') {
      this.title = 'IME Library';
      this.loadIME();
    } else if (type === 'DME') {
      this.title = 'DME Library';
      this.loadDME();
    }
    else if (type === 'ROA') {
      this.title = 'ROA Library';
      this.loadROA();
    }
    else if (type === 'CODELIST') {
      this.title = 'Code List Library';
      this.loadCodeList();
    }
  }

  // API CALLS
  loadIME() {
      this.spinner.start();
    this.jsignalsService.getAllIMERecords().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.setGridData(response);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching IME records:", error);
        this.snackBar.open("Failed to load IME records", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  loadDME() {
     this.spinner.start();
    this.jsignalsService.getAllDMERecords().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.setGridData(response);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching DME records:", error);
        this.snackBar.open("Failed to load DME records", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  loadROA() {
    this.spinner.start();
    this.jsignalsService.getAllROA().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.setGridData(response);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching ROA records:", error);
        this.snackBar.open("Failed to load ROA records", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  loadCodeList() {
    this.spinner.start();
    this.jsignalsService.getAllCodeList().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.setGridData(response);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching Code List records:", error);
        this.snackBar.open("Failed to load Code List records", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  // SET GRID DATA
  setGridData(data: any[]) {
    this.rowData = data;
    this.columnDefs = this.generateColumns(data);

    if (this.gridAPI) {
      this.gridAPI.setGridOption('rowData', this.rowData);
    }
  }

  // DYNAMIC COLUMN GENERATION
  generateColumns(data: any[]) {
    if (!data || data.length === 0) return [];

    return Object.keys(data[0]).map(key => ({
      headerName: this.jsignalsService.formatValues(key),
      headerTooltip: this.jsignalsService.formatValues(key),
      field: key,
      valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
      width: 200,
      tooltipValueGetter: (params) => `${this.jsignalsService.formatValues(key)}: ${this.jsignalsService.formatValues(params.value)}`
    }));
  }

  // GRID READY
  onGridReady(params: any) {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;

    if (this.rowData.length) {
      this.gridAPI.setGridOption('rowData', this.rowData);
    }
  }

  //  SEARCH FILTER
  onQuickFilterChanged(event: any) {
    const value = event.target.value;
    this.gridAPI.setGridOption('quickFilterText',value);
  }

  // PAGINATION
  onPaginationChanged() {
    if (this.gridAPI) {
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  onSearchChange(page: number) {
    if (this.gridAPI) {
      this.gridAPI.paginationGoToPage(page - 1);
    }
  }

  onPageSizeChanged() {
    if (this.gridAPI) {
      this.gridAPI.setGridOption('paginationPageSize', Number(this.pageSize));
    }
  }

  onBtNext() {
    this.gridAPI.paginationGoToNextPage();
  }

  onBtPrevious() {
    this.gridAPI.paginationGoToPreviousPage();
  }

  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }

}
